import { type ComponentProps, createContext, useContext, useMemo } from "react"

const GroupContext = createContext({ itemsCount: 0 })

export const GroupContextProvider = ({
  itemsCount,
  children
}: Pick<ComponentProps<typeof GroupContext.Provider>, "children"> & {
  itemsCount: number
}) => {
  const value = useMemo(() => ({ itemsCount }), [itemsCount])
  return <GroupContext.Provider value={value}>{children}</GroupContext.Provider>
}

export const useGroupContext = () => useContext(GroupContext)
